<template>
  <div :class="_.waterfall">
    <div :class="_.hd">
      <img
        v-if="theme.titleType === 'url'"
        :src="theme.title"
        :class="_.image"
      />
      <div v-else-if="theme.titleType === 'text'" :class="_.title">
        <div :class="_.primary" :style="{ color: theme.titleFontColor }">
          {{ theme.title }}
        </div>
        <div :class="_.divider"></div>
        <div :class="_.secondary" :style="{ color: theme.subTitleFontColor }">
          {{ theme.subTitle }}
        </div>
      </div>
    </div>
    <div :class="_.bd">
      <dmbc-base-masonry :col-count="2" :gap="9">
        <div
          v-for="(item, index) in data"
          :key="index"
          v-track="{
            name: '商品瀑布流-商品',
            id: `DianJiZiDingYiYeZiYuan`,
            resource: item,
            index: index,
            extra: getTrackExtra(item, index),
          }"
          :class="_.item"
          @click="$dmbcResourceClick(item)"
        >
          <dmbc-base-square>
            <img :src="item.icon" :class="_.cover" />
          </dmbc-base-square>
          <div :class="_.content">
            <div :class="_.name">
              {{ item.title }}
            </div>
            <div
              v-if="theme.showLabel === true && item.tags && item.tags.length"
              :class="_.tags"
            >
              <div
                v-for="tag in item.tags.slice(0, 3)"
                :key="tag"
                :class="_.tag"
              >
                {{ tag }}
              </div>
            </div>
            <div :class="_.extra">
              <div :class="_.price"><span>￥</span>{{ item.discountAmt }}</div>
              <div v-if="theme.showSellCount === true" :class="_.sales">
                销量 {{ item.sales }}
              </div>
            </div>
          </div>
        </div>
      </dmbc-base-masonry>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({})
</script>

<style lang="scss" module="_">
  .waterfall {
    border-radius: var(--border-radius);
    padding: 12px;
    font-size: 0;

    .hd {
      .image {
        width: 100%;
        height: auto;
      }

      .title {
        display: flex;
        align-items: center;

        .primary {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          line-height: 22px;
        }

        .divider {
          margin: 0 8px;
          width: 1px;
          height: 14px;
          background: #979797;
        }

        .secondary {
          font-size: 12px;
          color: #333333;
          line-height: 17px;
        }
      }
    }

    .bd {
      margin-top: 10px;

      .item {
        background: #ffffff;
        border-radius: 8px;
        overflow: hidden;

        .cover {
          object-fit: cover;
        }

        .content {
          padding: 8px;

          .name {
            font-size: 14px;
            font-weight: bold;
            color: #333333;
            line-height: 20px;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .tags {
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            .tag {
              margin-top: 6px;
              margin-right: 6px;
              height: 18px;
              padding: 0 4px;
              line-height: 18px;
              background: #ffe9ea;
              border-radius: 3px;
              font-size: 11px;
              color: #ff0e18;

              &:nth-child(2) {
                background: #fff4e6;
                color: #ff960a;
              }

              &:nth-child(3) {
                background: #e3f6eb;
                color: #009f40;
              }
            }
          }

          .extra {
            margin-top: 12px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .price {
              font-size: 16px;
              font-weight: bold;
              color: #ff111c;
              line-height: 16px;

              span {
                font-size: 11px;
              }
            }

            .sales {
              font-size: 12px;
              color: #bebebe;
              line-height: 12px;
            }
          }
        }
      }
    }
  }
</style>
